import React, { useLayoutEffect } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import { usePublicDonate } from '../../contexts/PublicDonateContext';
import DonateCatalogBrowse from '../../components/donate/DonateCatalogBrowse';

export default function PublicDonateCatalogPage() {
  const { addItem, itemCount, donateMode, setGuestMode, cart, removeItem, updateOutOfTownDays } = usePublicDonate();
  const { loading: authLoading, staff } = useAuth();
  const hasPortalSession = !authLoading && !!staff?.portal;

  useLayoutEffect(() => {
    if (authLoading) return;
    if (hasPortalSession) return;
    if (!donateMode) setGuestMode();
  }, [authLoading, hasPortalSession, donateMode, setGuestMode]);

  if (authLoading) {
    return (
      <Box sx={{ py: 5, display: 'flex', justifyContent: 'center' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!hasPortalSession && !donateMode) {
    return (
      <Box sx={{ py: 5, display: 'flex', justifyContent: 'center' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <DonateCatalogBrowse
      apiPrefix="/public/facets"
      cartPath="/donate/cart"
      addItem={addItem}
      itemCount={itemCount}
      cart={cart}
      removeItem={removeItem}
      updateOutOfTownDays={updateOutOfTownDays}
    />
  );
}
